<template>
    <v-container>
      <v-row>
        <v-col :cols="[this.$vuetify.breakpoint.smAndDown ? 12 : 6]">
          <v-img src="https://i.imgur.com/RqbCLRi.jpg" max-height="80vh" contain></v-img>
        </v-col>
        <v-col :cols="[this.$vuetify.breakpoint.smAndDown ? 12 : 6]">
          <div class="text-h2 mb-5">Contact Us</div>
          <v-list>
              <v-list-item-group color="primary">
                <v-list-item href="mailto:fapinteractive@gmail.com">
                  <v-list-item-icon>
                    <v-icon>mdi-gmail</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Email</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item href="https://www.reddit.com/message/compose?to=fapinteractive&subject=Fap%20Interactive%20Contact&message=" target="_blank">
                  <v-list-item-icon>
                    <v-icon>mdi-reddit</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Reddit</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  
      export default {
        name: 'contact',
        data: () => ({

        }),
        methods: {

        },
      }
  </script>